// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"35531de2","455":"74e86291","977":"e9cc5c53"}[chunkId] + ".chunk.js";
};